import React from 'react';

interface IconProps {
  /** Material Symbols name — e.g. 'add', 'person', 'dashboard' */
  name: string;
  /** Size in pixels; default 20 */
  size?: number;
  /** Whether the icon should be filled (default: outlined) */
  filled?: boolean;
  className?: string;
  /** aria-label for accessibility; omit if decorative */
  label?: string;
}

export const Icon: React.FC<IconProps> = ({ name, size = 20, filled = false, className = '', label }) => {
  const style: React.CSSProperties = {
    fontSize: `${size}px`,
    fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' ${size}`,
    lineHeight: 1,
  };

  return (
    <span
      className={`material-symbols-outlined select-none ${className}`}
      style={style}
      aria-hidden={label ? undefined : 'true'}
      aria-label={label}
    >
      {name}
    </span>
  );
};
